<ejs-dialog #modal [width]='largura' [height]='altura' 
  (open)="executarAntesDeAbrir()"
  (close)="tratarFechamento(modal)"
  (beforeClose)="executarAntesDeFechar($event)"
  [visible]='false' 
  [id]='id'
  [isModal]='true'
  [cssClass]="'custom-base-dialog pesquisa-modal'">

  <ng-template #footerTemplate>
    <button  ejs-buttom  class=" e-btn e-primary" data-ripple="true" (click)='clickOk()'>Ok</button>
    <button ejs-button  class="e-btn " data-ripple="true" (click)='fechar()'>Cancelar</button>
</ng-template>
  

<ng-template #header>

<div class="x-modal-header" style="background: #137c10;">

    <i class="x-modal-header-icon {{ iconCss }}"></i>

    <div class="x-modal-header-content">
    <h2 class="x-modal-header-title" [innerHTML]="titulo"></h2>
    <p class="x-modal-header-subtitle" [innerHTML]="subtitulo"></p>
    </div>

    <div class="x-modal-header-buttons" *ngIf='noActions === false'>
    <a class="full-screen" (click)='alterarTelaCheia()' [ngClass]="{ 'is-full-screen': estaEmTelaCheia }"></a>
    <a class="close" (click)='fechar()'></a>
    </div>

</div>

</ng-template>


<ng-template #content >  
  <div style="display: flex;flex-direction: column;height:100%;">
    <div style="flex-grow: 0;">
      <ng-container *ngIf="filtroDiretiva != null" [ngTemplateOutlet]="filtroDiretiva.templateRef"></ng-container>
    </div>
    <div style="flex-grow: 1;" #mainContent>
      <ng-container *ngIf="abriuModal" [ngTemplateOutlet]="conteudoDiretiva.templateRef" ></ng-container>
    </div>
  </div>
  
  
</ng-template>



</ejs-dialog>

